import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'
import { getUserIdForTicketMutation } from './ticketMutationUserId'

const deleteTicketByIdApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    const payload = {
      ...(data && typeof data === 'object' ? data : {}),
      user_id: getUserIdForTicketMutation(),
    }
    serviceCall({
      url: apiConstants.TICKET.DELETE_TICKET_BY_ID,
      method: 'delete',
      data: payload,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteTicketByIdApi;